import { MapPin } from "lucide-react";
import { Reveal } from "./Reveal";

const STORIES = [
  {
    quote:
      "My knee was quoted at $38,000 in Texas with a five-month wait. OravioCare had me walking on a new joint in Delhi within three weeks — the hospital felt like a five-star hotel.",
    name: "Michael R., 58",
    location: "Austin, USA",
    procedure: "Knee Replacement",
    saved: "$29,000 saved",
  },
  {
    quote:
      "After two failed IVF cycles in London we were emotionally and financially drained. The OravioCare team treated us like family — and we are now expecting our daughter in October.",
    name: "Elena K., 41",
    location: "London, UK",
    procedure: "IVF Treatment",
    saved: "£8,400 saved",
  },
  {
    quote:
      "Full-mouth implants for less than a quarter of the Dublin quote, plus a week recovering in Kerala. My dentist at home reviewed the work and called it impeccable.",
    name: "James & Patricia W.",
    location: "Dublin, Ireland",
    procedure: "Dental Implants",
    saved: "€9,800 saved",
  },
];

export default function Testimonials() {
  return (
    <section id="stories" className="scroll-mt-28 bg-ivory py-28 sm:py-36" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal className="max-w-2xl">
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">Patient stories</p>
          <h2 className="mt-5 font-serif text-4xl font-medium leading-[1.08] tracking-tight text-brand-green sm:text-5xl">
            They flew home healed — and wealthier.
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-8 lg:grid-cols-3">
          {STORIES.map((s, i) => (
            <Reveal key={s.name} delay={i * 0.12}>
              <figure
                data-testid={`testimonial-card-${i}`}
                className="flex h-full flex-col justify-between rounded-3xl border border-sand bg-white p-8 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_30px_70px_rgba(8,61,52,0.12)]"
              >
                <div>
                  <span className="font-serif text-6xl leading-none text-gold">“</span>
                  <blockquote className="-mt-3 font-serif text-xl italic leading-relaxed text-ink">
                    {s.quote}
                  </blockquote>
                </div>
                <figcaption className="mt-8 border-t border-cream pt-6">
                  <div className="flex items-center justify-between gap-3">
                    <div>
                      <p className="text-sm font-semibold text-ink">{s.name}</p>
                      <p className="mt-1 flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.15em] text-sage">
                        <MapPin size={11} /> {s.location} · {s.procedure}
                      </p>
                    </div>
                    <span className="shrink-0 rounded-full bg-brand-green px-3 py-1.5 font-mono text-[10px] tracking-wider text-ivory">
                      {s.saved}
                    </span>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
